import { c as _c } from "react/compiler-runtime";
import { usePlaybookBuilderStore } from './use-store';
const COLLAPSIBLE_KINDS = new Set(['branch', 'conditional']);
const useCollapsedNodes = () => {
  const $ = _c(15);
  const {
    data,
    set
  } = usePlaybookBuilderStore();
  const {
    collapsedNodeIds,
    graph
  } = data;
  let t0;
  if ($[0] !== collapsedNodeIds) {
    t0 = nodeId => collapsedNodeIds.includes(nodeId);
    $[0] = collapsedNodeIds;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isCollapsed = t0;
  let t1;
  if ($[2] !== collapsedNodeIds || $[3] !== isCollapsed || $[4] !== set) {
    t1 = nodeId_0 => {
      set({
        collapsedNodeIds: isCollapsed(nodeId_0) ? collapsedNodeIds.filter(id => id !== nodeId_0) : [...collapsedNodeIds, nodeId_0]
      });
    };
    $[2] = collapsedNodeIds;
    $[3] = isCollapsed;
    $[4] = set;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const toggleCollapsed = t1;
  let t2;
  if ($[6] !== collapsedNodeIds || $[7] !== graph || $[8] !== set) {
    t2 = () => {
      const collapsibleIds = graph.nodes.filter(_temp).map(_temp2);
      if (collapsibleIds.length === 0) {
        return;
      }
      const allCollapsed = collapsibleIds.every(id_0 => collapsedNodeIds.includes(id_0));
      set({
        collapsedNodeIds: allCollapsed ? [] : collapsibleIds
      });
    };
    $[6] = collapsedNodeIds;
    $[7] = graph;
    $[8] = set;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const toggleAll = t2;
  let t3;
  if ($[10] !== collapsedNodeIds || $[11] !== isCollapsed || $[12] !== toggleAll || $[13] !== toggleCollapsed) {
    t3 = {
      isCollapsed,
      toggleCollapsed,
      toggleAll,
      collapsedNodeIds
    };
    $[10] = collapsedNodeIds;
    $[11] = isCollapsed;
    $[12] = toggleAll;
    $[13] = toggleCollapsed;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};
export default useCollapsedNodes;
function _temp(n) {
  return COLLAPSIBLE_KINDS.has(n.kind);
}
function _temp2(n_0) {
  return n_0.id;
}